import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api/menuitem';
import { MenuModule } from 'primeng/menu';
import { Subscription } from 'rxjs';
import { NotifictChangeListService } from 'src/app/site/shopping-car/services/notifict-change-list.service';
import { WishList } from 'src/app/utils/functions/wishList';
import { IdleService } from '../../services/idle.service';
import { SearchService } from '../../services/search.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'custom-header',
  templateUrl: './custom-header.component.html',
  styleUrls: ['./custom-header.component.css']
})
export class CustomHeaderComponent implements OnInit, OnDestroy{
  searching: string = '';
  searchLabel: string = '';
  hiddenElement: Boolean = false;
  isLoggedUser!: boolean;
  user : any = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!) : {};
  lastSearch: string = '';
  @Input() logoImage: string = '';
  @Input() companyName: string = '';

  constructor(
    private router: Router,
    private wishList : WishList,
    private notificChangeListService: NotifictChangeListService,
    private idleService: IdleService,
    private _searchService: SearchService,
    private navigationService : NavigationService
  ){}

  options!: MenuItem[];
  activeOption!: MenuItem;

  optionsPop!: MenuModule[] ;
  activeOptionPop!: MenuModule;
  searchSubscription!: Subscription;
  shoppingCartNotification!: Subscription;
  cantShoppingCartItems: number = 0;

  ngOnInit(): void {
    this.isLoggedUser = localStorage.getItem('token') ? true : false;
    this.cantShoppingCartItems = this.wishList.countForItems();
    this.searchLabel = `Buscar en ${this.companyName}`;
    this.options = [
      {
        label: 'INICIO',
        queryParams:{ url: '/' }
      },
      {
        label: 'CATÁLOGO DE PRODUCTOS',
        queryParams:{ url: '/product-catalog' }
      },
      {
        label: 'EVENTOS',
        queryParams:{ url: '/events' }
      },
      {
        label: 'NOTICIAS',
        queryParams:{ url: '/news' }
      },
      {
        label: 'MI CUENTA',
        queryParams:{ url: '/account' },
        command: () => {
          localStorage.setItem('goToCount', 'true');
        }
      }
    ];

    this.optionsPop = [
      {
        label: 'INICIO',
        routerLink: '/'
      },
      {
        label: 'CATÁLOGO DE PRODUCTOS',
        routerLink: '/product-catalog'
      },
      {
        label: 'EVENTOS',
        routerLink: '/events'
      },
      {
        label: 'NOTICIAS',
        routerLink: '/news'
      },
      {
        label: 'MI CUENTA',
         routerLink: '/account',
         command: () => {
          localStorage.setItem('goToCount', 'true');
         }
      }
    ];

    this.activeOption = this.options.find((option) => option.queryParams!['url'] == this.router.url)!;
    this.searchSubscription = this._searchService.searchTerm$.subscribe(value => {
      this.searching = value;
    });

    this.shoppingCartNotification = this.notificChangeListService.updateNotifications$.subscribe((count)=> {
      this.cantShoppingCartItems = count!;
    })
  }

  onActiveItemChange(event: any){
    const url = event?.queryParams?.url ?? null;
    if (url) {
      this.searching = '';
      this.router.navigate([url]);
    }
  }

  onSearchChange(value: string) {
    this._searchService.value = value;
  }

  search(query: string){
    if(query.trim() === '' && this.lastSearch === ''){
      return;
    }

    this.lastSearch = query;
    let params = {};

    if(query !== ''){
      params = {
        queryParams: {search: query },
        skipLocationChange: false
      }
    }

    this.router.navigate(['product-catalog'], params);
  }

  goToLogin() {
    this.router.navigate(['auth/login']);
  }

  logOut() {
    const navigationHistory = this.navigationService.getHistory();
    this.idleService.stopMonitoring();
    this.isLoggedUser = false;
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('goToCount');
    if(navigationHistory[2] == '/account'){
      this.router.navigate(['']);
    } else if(navigationHistory[2] == '/shopping-car'){
      window.location.reload();
    }
  }

  ngOnDestroy() {
    this.shoppingCartNotification.unsubscribe();
    this.searchSubscription.unsubscribe();
  }
}
